export const CONFIG_MODES = {
    PACKAGE_COLLECTION: 'package_collection_mode',
    PACKAGE_FRACTION: 'package_fraction_mode'
}

export const STORE_CONFIG = {
    [CONFIG_MODES.PACKAGE_COLLECTION]: [
        {
            mode: 'WPS',
            title: 'Worek na sklep',
            description: 'Opakowania skanowane przez wszystkie kasy i aplikacje trafiają do jednego worka',
            icons: [
                { img: 'mobile.svg' },
                { img: 'arrow.svg', style: 'width: calc(var(--width) / 2)' },
                { img: 'plastic-bag-full.svg' },
                { img: 'arrow.svg', style: 'width: calc(var(--width) / 2); transform: rotate(180deg)' },
                { img: 'cash.svg' }
            ],
            disabled: true
        },
        {
            mode: 'WPK',
            title: 'Worek na stanowisko',
            description: 'Każde stanowisko kasowe lub użytkownik aplikacji wkłada opakowania do własnego worka',
            icons: [
                { img: 'mobile.svg' },
                { img: 'arrow.svg', style: 'width: calc(var(--width) / 2)' },
                { img: 'plastic-bag-full.svg', style: 'margin-right: 0.5rem' },
                { img: 'cash.svg' },
                { img: 'arrow.svg', style: 'width: calc(var(--width) / 2)' },
                { img: 'plastic-bag-full.svg' }
            ]
        }
    ],
    [CONFIG_MODES.PACKAGE_FRACTION]: [
        {
            mode: 'SINGLE',
            title: 'Osobne frakcje (zbiórka selektywna)',
            description: 'Każda frakcja ma swoje własne worki',
            icons: [
                { img: 'plastic-bag.svg' },
                { img: 'metal-bag.svg' },
                { img: 'glass-bag.svg' }
            ]
        },
        {
            mode: 'MIX',
            title: 'Mix frakcji (zbiórka mieszana)',
            description: 'Butelki plastikowe i puszki metalowe są zbierane do tego samego worka',
            icons: [
                { img: 'mix-bag.svg' },
                { img: 'glass-bag.svg' }
            ]
        }
    ]
}